import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import { useRef } from 'react'
import { Header, HEADER_HEIGHT } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { useQueryShipmentReadinessOverviewUrl } from './api/useQueryShipmentReadinessOverviewUrl'

export const ShipmentReadinessOverview: React.FC = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const { data: url, isLoading, error } = useQueryShipmentReadinessOverviewUrl()

  return (
    <Box>
      <Header>
        <HeaderTitle isBeta title="出荷判定" />
      </Header>
      <Box sx={{ padding: 0 }}>
        {isLoading && (
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              height: `calc(100vh - var(--banner-height, 0px) - ${HEADER_HEIGHT}px)`,
            }}
            spacing={2}
          >
            <CircularProgress size={48} />
            <Typography variant="body2" color="text.secondary">
              読み込み中...
            </Typography>
          </Stack>
        )}
        {!isLoading && error && (
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              height: `calc(100vh - var(--banner-height, 0px) - ${HEADER_HEIGHT}px)`,
              padding: 3,
            }}
            spacing={1}
          >
            <Typography color="error" variant="h6">
              ダッシュボードの読み込みに失敗しました
            </Typography>
            {error instanceof Error && (
              <Typography color="error" variant="body2">
                {error.message}
              </Typography>
            )}
          </Stack>
        )}
        {!isLoading && url && (
          <Box
            component="iframe"
            ref={iframeRef}
            src={url}
            title="出荷判定"
            allow="fullscreen"
            // 埋め込み先は協力会社(日本RAD)の既成ダッシュボード(Konekti EX)であり、Grafana OSS のセルフホスティング
            // Grafanaの動作要件により、allow-same-origin と allow-scripts の同時指定が必要（一般的に避けるべきとされている）
            // PoCとして、短期間(1ヶ月程度)・限定ユーザー(2社の管理者数名)での提供のため、リスクを許容する
            sandbox="allow-same-origin allow-scripts"
            sx={{
              width: '100%',
              height: `calc(100vh - var(--banner-height, 0px) - ${HEADER_HEIGHT}px)`,
              border: 0,
              boxSizing: 'border-box',
            }}
          />
        )}
      </Box>
    </Box>
  )
}
